module.exports = __webpack_public_path__ + "static/media/golf-carousel-1366x1024.f1b95e2b.jpg";